import VirtualPath from 'meta/utils/virtualPath'

// this file sets the public path for webpack
// this path is used to resolve loading of assets like referencing a font from a CSS file or dynamically loading a JS module

// __webpack_public_path__ needs to be assigned to as a free variable in order to be picked up by webpack
// eslint-disable-next-line no-undef
__webpack_public_path__ = `${VirtualPath}/_Frontend/dist/modules/`
